import { OdataManager } from '@/api/odata/odata-manager';
import { Register } from '@/api/model/interfaces';

export default class AsBuiltReportsOdata extends OdataManager<Register> {}
